import _ from "lodash"
import { UserStorage } from "utils/userStorage"

interface Window {
  Logic: any
  IntelliFactory: any
  Trading: any
}

declare var window: Window

export const removeAddonChart = (type: string, _controller: any) => {
  _controller.RemoveIndicator.call(null, type)
}

export const setAddonChart = (
  chartSetting: object,
  type: string,
  _controller: any,
  term: string = null,
  keys: Array<string | null> = [],
  upDate = false
) => {
  if (!_controller) return
  const viewType = _controller.Chart.get_Chart().get_View()
  if (!(viewType instanceof window.Trading.Chart.TSView)) return
  const _getOptionParamValue = getOptionParamValue(chartSetting, "addon", term)
  let paraList = window.Logic.Helper.emptyList()
  let dispList = window.Logic.Helper.emptyList()
  let scaleList = window.Logic.Helper.emptyList()
  switch (type) {
    case "AverageN":
      paraList = window.IntelliFactory.WebSharper.List.ofArray([
        window.Trading.Chart.Proto.Controller.intParam(
          "Ma1",
          _getOptionParamValue("AverageN", "AverageN_1", 6)
        ),
        window.Trading.Chart.Proto.Controller.intParam(
          "Ma2",
          _getOptionParamValue("AverageN", "AverageN_2", 12)
        ),
        window.Trading.Chart.Proto.Controller.intParam(
          "Ma3",
          _getOptionParamValue("AverageN", "AverageN_3", 24)
        ),
        window.Trading.Chart.Proto.Controller.intParam(
          "Ma4",
          _getOptionParamValue("AverageN", "AverageN_4", 36)
        ),
        window.Trading.Chart.Proto.Controller.intParam(
          "Ma5",
          _getOptionParamValue("AverageN", "AverageN_5", 48)
        ),
      ])
      dispList = window.IntelliFactory.WebSharper.List.ofArray([
        ["Ma1", Number(_.includes(keys, "AverageN_1"))],
        ["Ma2", Number(_.includes(keys, "AverageN_2"))],
        ["Ma3", Number(_.includes(keys, "AverageN_3"))],
        ["Ma4", Number(_.includes(keys, "AverageN_4"))],
        ["Ma5", Number(_.includes(keys, "AverageN_5"))],
      ])
      break
    case "EMA":
      paraList = window.IntelliFactory.WebSharper.List.ofArray([
        window.Trading.Chart.Proto.Controller.intParam(
          "Short",
          _getOptionParamValue("EMA", "EMA_1", 6)
        ),
        window.Trading.Chart.Proto.Controller.intParam(
          "Middle",
          _getOptionParamValue("EMA", "EMA_2", 12)
        ),
        window.Trading.Chart.Proto.Controller.intParam(
          "Long",
          _getOptionParamValue("EMA", "EMA_3", 24)
        ),
      ])
      dispList = window.IntelliFactory.WebSharper.List.ofArray([
        ["Short", Number(_.includes(keys, "EMA_1"))],
        ["Middle", Number(_.includes(keys, "EMA_2"))],
        ["Long", Number(_.includes(keys, "EMA_3"))],
      ])
      break
    case "KSBolinger":
      paraList = window.IntelliFactory.WebSharper.List.ofArray([
        window.Trading.Chart.Proto.Controller.intParam(
          "Kikan",
          _getOptionParamValue("KSBolinger", "BolingerMa", 12)
        ),
        window.Trading.Chart.Proto.Controller.dblParam(
          "Sigma1",
          _getOptionParamValue("KSBolinger", "Bolinger_1", 1)
        ),
        window.Trading.Chart.Proto.Controller.dblParam(
          "Sigma2",
          _getOptionParamValue("KSBolinger", "Bolinger_2", 2)
        ),
        window.Trading.Chart.Proto.Controller.dblParam(
          "Sigma3",
          _getOptionParamValue("KSBolinger", "Bolinger_3", 3)
        ),
      ])
      dispList = window.IntelliFactory.WebSharper.List.ofArray([
        ["Sma", Number(_.includes(keys, "BolingerMa"))],
        ["BolSigma1", Number(_.includes(keys, "Bolinger_1"))],
        ["BolSigma2", Number(_.includes(keys, "Bolinger_2"))],
        ["BolSigma3", Number(_.includes(keys, "Bolinger_3"))],
        ["BolSigma1m", Number(_.includes(keys, "Bolinger_1"))],
        ["BolSigma2m", Number(_.includes(keys, "Bolinger_2"))],
        ["BolSigma3m", Number(_.includes(keys, "Bolinger_3"))],
      ])
      break
    case "Envelope":
      paraList = window.IntelliFactory.WebSharper.List.ofArray([
        window.Trading.Chart.Proto.Controller.intParam(
          "Kikan",
          _getOptionParamValue("Envelope", "Envelope_Ma", 12)
        ),
        window.Trading.Chart.Proto.Controller.dblParam(
          "Sigma1",
          _getOptionParamValue("Envelope", "Envelope_1", 0.3)
        ),
        window.Trading.Chart.Proto.Controller.dblParam(
          "Sigma2",
          _getOptionParamValue("Envelope", "Envelope_2", 0.6)
        ),
        window.Trading.Chart.Proto.Controller.dblParam(
          "Sigma3",
          _getOptionParamValue("Envelope", "Envelope_3", 0.9)
        ),
      ])
      dispList = window.IntelliFactory.WebSharper.List.ofArray([
        ["Sma", Number(_.includes(keys, "Envelope_Ma"))],
        ["EnvSigma1", Number(_.includes(keys, "Envelope_1"))],
        ["EnvSigma2", Number(_.includes(keys, "Envelope_2"))],
        ["EnvSigma3", Number(_.includes(keys, "Envelope_3"))],
        ["EnvSigma1m", Number(_.includes(keys, "Envelope_1"))],
        ["EnvSigma2m", Number(_.includes(keys, "Envelope_2"))],
        ["EnvSigma3m", Number(_.includes(keys, "Envelope_3"))],
      ])
      break

    case "Ichimoku":
      paraList = window.IntelliFactory.WebSharper.List.ofArray([
        window.Trading.Chart.Proto.Controller.intParam(
          "TenkanKikan",
          _getOptionParamValue("Ichimoku", "Tenkan_Value", 9)
        ),
        window.Trading.Chart.Proto.Controller.intParam(
          "KijunKikan",
          _getOptionParamValue("Ichimoku", "Kijyun_Value", 26)
        ),
        window.Trading.Chart.Proto.Controller.intParam(
          "SpanKikan",
          _getOptionParamValue("Ichimoku", "Span_Value", 26)
        ),
      ])
      break
    case "ParabolicDiv":
      paraList = window.IntelliFactory.WebSharper.List.ofArray([
        window.Trading.Chart.Proto.Controller.dblParam(
          "AfInit",
          _getOptionParamValue("ParabolicDiv", "Parabolic_AF", 0.02)
        ),
        window.Trading.Chart.Proto.Controller.dblParam(
          "Step",
          _getOptionParamValue("ParabolicDiv", "Parabolic_Step", 0.02)
        ),
        window.Trading.Chart.Proto.Controller.dblParam(
          "MaxVal",
          _getOptionParamValue("ParabolicDiv", "Parabolic_Max", 0.2)
        ),
      ])
      break
    case "HLBand":
      paraList = window.IntelliFactory.WebSharper.List.ofArray([
        window.Trading.Chart.Proto.Controller.intParam(
          "HKikan",
          _getOptionParamValue("HLBand", "HLBand_highPeriod", 20)
        ),
        window.Trading.Chart.Proto.Controller.intParam(
          "LKikan",
          _getOptionParamValue("HLBand", "HLBand_lowPeriod", 20)
        ),
      ])
      break

    case "ATRChannel":
      paraList = window.IntelliFactory.WebSharper.List.ofArray([
        window.Trading.Chart.Proto.Controller.intParam(
          "Kikan",
          _getOptionParamValue("ATRChannel", "ATRChannel_Lma", 25)
        ),
        window.Trading.Chart.Proto.Controller.intParam(
          "ATRKikan",
          _getOptionParamValue("ATRChannel", "ATRChannel_Atr", 25)
        ),
        window.Trading.Chart.Proto.Controller.dblParam(
          "Sigma1",
          _getOptionParamValue("ATRChannel", "ATRChannel_1", 1)
        ),
        window.Trading.Chart.Proto.Controller.dblParam(
          "Sigma2",
          _getOptionParamValue("ATRChannel", "ATRChannel_2", 2)
        ),
        window.Trading.Chart.Proto.Controller.dblParam(
          "Sigma3",
          _getOptionParamValue("ATRChannel", "ATRChannel_3", 3)
        ),
      ])
      dispList = window.IntelliFactory.WebSharper.List.ofArray([
        ["Lma", Number(_.includes(keys, "ATRChannel_Lma"))],
        ["ATRChannelSigma1", Number(_.includes(keys, "ATRChannel_1"))],
        ["ATRChannelSigma2", Number(_.includes(keys, "ATRChannel_2"))],
        ["ATRChannelSigma3", Number(_.includes(keys, "ATRChannel_3"))],
        ["ATRChannelSigma1m", Number(_.includes(keys, "ATRChannel_1"))],
        ["ATRChannelSigma2m", Number(_.includes(keys, "ATRChannel_2"))],
        ["ATRChannelSigma3m", Number(_.includes(keys, "ATRChannel_3"))],
      ])
      break

    case "Kaiki":
      paraList = window.IntelliFactory.WebSharper.List.ofArray([
        window.Trading.Chart.Proto.Controller.intParam(
          "Kikan",
          _getOptionParamValue("Kaiki", "Kikan", 25)
        ),
        window.Trading.Chart.Proto.Controller.intParam(
          "FutureSpan",
          _getOptionParamValue("Kaiki", "FutureSpan", 0)
        ),
        window.Trading.Chart.Proto.Controller.dblParam(
          "Sigma1",
          _getOptionParamValue("Kaiki", "Kaiki_1", 1)
        ),
        window.Trading.Chart.Proto.Controller.dblParam(
          "Sigma2",
          _getOptionParamValue("Kaiki", "Kaiki_2", 2)
        ),
        window.Trading.Chart.Proto.Controller.dblParam(
          "Sigma3",
          _getOptionParamValue("Kaiki", "Kaiki_3", 3)
        ),
      ])
      dispList = window.IntelliFactory.WebSharper.List.ofArray([
        ["Kaiki", Number(_.includes(keys, "Kikan"))],
        ["KaikiSigma1", Number(_.includes(keys, "Kaiki_1"))],
        ["KaikiSigma2", Number(_.includes(keys, "Kaiki_2"))],
        ["KaikiSigma3", Number(_.includes(keys, "Kaiki_3"))],
        ["KaikiSigma1m", Number(_.includes(keys, "Kaiki_1"))],
        ["KaikiSigma2m", Number(_.includes(keys, "Kaiki_2"))],
        ["KaikiSigma3m", Number(_.includes(keys, "Kaiki_3"))],
      ])
      break

    case "Vwap":
      break
    default:
      break
  }

  try {
    _controller.AddIndicator.call(null, [type, paraList, dispList, scaleList])
  } catch {
    try {
      _controller.UpdateIndicatorParam.call(null, [
        type,
        paraList,
        dispList,
        scaleList,
      ])
    } catch {
      UserStorage.TechChart.remove()
    }
  }
}

export const getOptionParamValue = (
  chartSetting: object,
  group: string,
  term: string
) => {
  return (item: string, key: string, origin: boolean | number) => {
    const value = _.get(chartSetting, [group, item, "_Def", key, term], null)
    if (value) return Number(value)
    return Number(
      _.get(chartSetting, [group, item, "_Def", key, "default"], origin)
    )
  }
}
